import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PhotosFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="photosFilled" ref={ref} {...props}>
      <path d="M16,2.26H5A2.75,2.75,0,0,0,2.26,5V16A2.75,2.75,0,0,0,5,18.72H16A2.75,2.75,0,0,0,18.72,16V5A2.75,2.75,0,0,0,16,2.26ZM7.73,11.47c.56-.5.92-.3,1.38,0a1.13,1.13,0,0,0,1.41,0c.5-.38,1.77-1.54,2.28-1.88a1.14,1.14,0,0,1,1.52.1,16.94,16.94,0,0,1,1.61,1.75v4c0,.31-.17.29-.71.29H5.49c-.44,0-.44-.24-.44-.48V14S7.17,12,7.73,11.47ZM6.86,8A1.15,1.15,0,1,1,8,9.17,1.16,1.16,0,0,1,6.86,8ZM18,21.73H6a.75.75,0,0,1,0-1.5H18A2.25,2.25,0,0,0,20.23,18V6a.75.75,0,0,1,1.5,0V18A3.76,3.76,0,0,1,18,21.73Z" />
    </Icon>
  ),
) as IconWithRender;

PhotosFilledIcon.displayName = 'PhotosFilledIcon';
PhotosFilledIcon.renderIcon = (props) => <PhotosFilledIcon {...props} />;
export default PhotosFilledIcon;
